'use client'
import React, { useContext } from "react"
import moment from "moment"
import { useRouter } from "next/navigation"
import Grid from "@mui/material/Grid"
import PhoneIcon from '@mui/icons-material/Phone'
import IconButton from "@mui/material/IconButton"
import {TranslationContext} from "@/configs/context"
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import BusinessIcon from '@mui/icons-material/Business'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import {Box, Typography, Button, Paper, useMediaQuery, useTheme, Stack} from "@mui/material"
import { GlassBox, ToolPadGlassBox } from "../components/custom/box"


const FooterWrapper: React.FC = () => {
  const theme = useTheme()
  const router = useRouter()
  // @ts-expect-error:next-line
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  const links = [
    {
      label: t('translation:footer.about'),
      link: "/about"
    },
    {
      label: t('translation:footer.privacy'),
      link: "/privacy"
    },
    {
      label: t('translation:footer.cgu'),
      link: "/cgu"
    },
    {
      label: t('translation:faq.title'),
      link: "/faq"
    },
  ]

  const linkSxProps = {
    mb: 4,
    width: "100%",
    whiteSpace: !matchMd && "nowrap",
    overflowX: !matchMd && "auto",
  }

  const socialNetworks = [
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/company/djotta",
      label: "LinkedIn"
    },
    {
      icon: <FacebookIcon />,
      link: "https://web.facebook.com/profile.php?id=61571770161779",
      label: "Facebook"
    },
  ]

  const companyAddress = [
    {
      icon: <BusinessIcon />,
      label: t('translation:footer.company_location'),
    },
    {
      icon: <PhoneIcon />,
      label: t('translation:footer.contact2'),
      isPhone: true
    },
    {
      icon: <AlternateEmailIcon />,
      label: t('translation:footer.email'),
      isEmail: true
    },
  ]

  return (
    <Box
      id="footer-section"
      sx={{
        color: "text.primary",
        pt: { xs: 2, md: 8 },
        pb: { xs: 2, md: 0 },
      }}
    >
      <GlassBox sx={{ px: 2, py: { xs: 6, md: 8 }}}>
        <Grid
          container
          alignItems="flex-start"
          spacing={{ xs: 1, lg: 3 }}
          justifyContent={"center"}
        >
          <Grid
            sx={{ mb: { xs: 4, md: 0 } }}
            size={{ xs: 12, sm: 12., md: 6, lg: 6, xl: 5 }}
          >
            <Typography variant={matchMd ? "h4" : "h6"} sx={{ mb: 1, fontWeight: 500 }}>
              {t('translation:appbar.app_name')}
            </Typography>
            <Typography variant={matchMd ? "body1" : "body2"} sx={{ mb: 3 }}>
              {t('translation:hero.subtitle')}
            </Typography>
            {companyAddress.map(function (address) {
              let options = {}

              if (address.isPhone) {
                options = {
                  component: "a",
                  href: `tel:${address.label.replace(/\s+/g, '')}`
                }
              }
              if (address.isEmail) {
                options = { component: "a", href: `mailto:${address.label}` }
              }

              return (
                <Stack sx={{ mb: 1 }} direction="row" alignItems="center" key={address.label}>
                  {address.icon}
                  <Typography
                    sx={{ ml: 1, textDecoration: "none", color: "text.primary", }}
                    variant={matchMd ? "body1" : "body2"}
                    {...options}
                  >
                    {address.label}
                  </Typography>
                </Stack>
              )
            })}
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 5, lg: 5, xl: 4 }}
            sx={{ textAlign: "center" }}
          >
            <Box
              sx={linkSxProps}
              className={matchMd ? "" : "no-scrollbar"}
            >
              {links.map((link) => (
                <Button
                  size="small"
                  variant="glass"
                  href={link.link}
                  sx={{ py: 0, margin: .5, color: "text.primary" }}
                  key={`footer-link-${link.link}`}
                  onClick={(event) => {
                    event.preventDefault()
                    router.push(link.link)
                  }}    
                >
                  {link.label}
                </Button>
              ))}
            </Box>
            <Box
              sx={linkSxProps}
              className={matchMd ? "" : "no-scrollbar"}
            >
              {socialNetworks.map((link, index) => (
                // @ts-expect-error:next-line
                <IconButton
                  size="large"
                  sx={{ mx: 1, color: "text.primary" }}
                  href={link.link}
                  target="_blank"
                  variant="glass"
                  key={"sn-" + index}
                  aria-label={link.label}
                  // onClick={() => { window.open(link.link, '_blank') }}
                >
                  {link.icon}
                </IconButton>
              ))}
            </Box>
            <Typography variant="body2" sx={{ marginTop: "1rem" }}>
              {t('translation:footer.trademark', { year: moment().format('YYYY') })}
            </Typography>
          </Grid>
        </Grid>
      </GlassBox>
    </Box>
  )
}

export default FooterWrapper
